import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-down-icon',
  templateUrl: './navigation-arrow-down.component.html'
})
export class NavigationArrowDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
